import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getDocumentDetail(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getDocumentDetails, domainData.t, params.fileId); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentDetails.Get", start, null);
            yield put({ type: types.HP_GET_DOCUMENT_DETAIL_SUCCESS, docDetails: response, docName: params.fileName, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentDetails.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_DOCUMENT_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentDetails.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getBenefitDocuments(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData.t && params.planId) {//Bug-34585
                const response = yield call(hpServicesApi.DocumentsApi.getBenefitDocuments, domainData.t, params.planId, params.memId); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocuments", start, null);
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENTS_SUCCESS, benefitDocuments: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENTS_FAILURE, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocuments.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENTS_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocuments.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getBenefitDocument(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData.t && params.documentName) {//Bug-34585
                const response = yield call(hpServicesApi.DocumentsApi.getBenefitDocument, domainData.t, params.documentName); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocument", start, null);
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENT_SUCCESS, benefitDocumentData: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENT_FAILURE, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocument.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_BENEFIT_DOCUMENT_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitDocument.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getAuthorizationApprovalLetter(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getAuthorizationApprovalLetterUrl, domainData.t, params.authorizationHccId); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServicesSaga.Authorizations.GetAuthorizationApprovalLetterUrl.Get", start, null);
            yield put({ type: types.HP_GET_AUTHORIZATION_APPROVAL_LETTER_SUCCESS, authorizationApprovalLetter: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Authorizations.GetAuthorizationApprovalLetterUrl.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_EOB_DOCUMENT_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Authorizations.GetAuthorizationApprovalLetterUrl.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getDocuments() {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getDocumentsList, domainData.t); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentsList.Get", start, null);
            yield put({ type: types.HP_GET_DOCUMENTS_LIST_SUCCESS, docs: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentsList.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_DOCUMENTS_LIST_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetDocumentsList.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getInvoicePDF(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getInvoicePDF, domainData.t, params.MemberId, params.InvoiceNumber); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetInvoicePDF.Get", start, null);
            yield put({ type: types.HP_GET_INVOICE_PDF_SUCCESS, invoicePDF: response, invoicePDFName: params.InvoiceNumber, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetInvoicePDF.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_INVOICE_PDF_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetInvoicePDF.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}



export function* requestNewIdCard(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.requestIdCard, domainData.t, params.memberId); //t = access token
            logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.RequestNewIdCard.Post", start, null);
            yield put({ type: types.HP_REQUEST_NEW_IDCARD_SUCCESS, response: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.RequestNewIdCard.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_REQUEST_NEW_IDCARD_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.RequestNewIdCard.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getEob(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getEobDocument, domainData.t, params.memId, params.claimId); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServicesSaga.Claims.GetEobDocument.Get", start, null);
            yield put({ type: types.HP_GET_EOB_DOCUMENT_SUCCESS, eobDocument: response, isFetching: false });

            //if (domainData && domainData.t && domainData.aai && params.claimId) {
            //    const response = yield call(getEobDocument, domainData.t, domainData.aai, params.claimId); //t = access token, aai = American Airlines id
            //    logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetEobDocument.Get", start, null);
            //    yield put({ type: types.HP_GET_EOB_DOCUMENT_SUCCESS, eobDocument: response, isFetching: false });
            //}
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetEobDocument.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_EOB_DOCUMENT_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetEobDocument.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getIdCardPdf(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    let memberId = params.memberId || domainData.aai;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t && memberId) {
                const response = yield call(hpServicesApi.DocumentsApi.getIdCardPdf, domainData.t, memberId);
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardPdf.Get", start, null);
                yield put({ type: types.HP_GET_IDCARD_SUCCESS, idCardPdf: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardPdf.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_IDCARD_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardPdf.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getIdCardImages(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    let memberId = params.memberId || domainData.aai;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t && memberId) {
                const response = yield call(hpServicesApi.DocumentsApi.getIdCardImage, domainData.t, memberId);
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardImages.Get", start, null);
                yield put({ type: types.HP_GET_IDCARD_IMAGE_SUCCESS, idCardImage: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardImages.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_IDCARD_IMAGE_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.IdCard.GetIdCardImages.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getForm(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.DocumentsApi.getForm, domainData.t, params.formName); //t = access token
            logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetForm.Get", start, null);
            yield put({ type: types.HP_GET_FORM_SUCCESS, form: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetForm.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_FORM_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Documents.GetFORM.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}